<ng-container [formGroup]="parentForm">
  <div class="d-flex" style="gap: 10px">
    <mat-form-field appearance="outline" style="flex: auto">
      <mat-label>{{'member.permitNumber' | translate }}</mat-label>
      <input matInput formControlName="permitNumber" [readonly]="readonly" (blur)="onBlur()">
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: auto">
      <mat-label>{{'member.firstName' | translate }}</mat-label>
      <input matInput formControlName="firstName" [readonly]="readonly">
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: auto">
      <mat-label>{{'member.lastName' | translate }}</mat-label>
      <input matInput formControlName="lastName" [readonly]="readonly">
    </mat-form-field>

    @if (parentForm.get('permitNumber').value !== previousPermitNumber && hasChangeDate) {
      <odq-date-input
        [placeholder]="'form.changeDate' | translate" [readonly]="readonly">
      </odq-date-input>
    }
  </div>

</ng-container>
